const BASE_API = process.env.MIX_ENDLESS_API_URL

const state = {
	applications: null,
}

const getters = {
	applicationsGetter: ({applications}) => applications,
}

const mutations = {
	setApplications: (state, payload) => state.applications = payload,
}

const actions = {
	async getApplications({commit}) {
		const res = await this.$axios.get(`${BASE_API}/language-school-applications`)
		commit('setApplications', res.data.result.data)
	},
}

export default {namespaced: true, state, getters, mutations, actions}
